import { makeStyles } from '@mui/styles';
import React from 'react';
import { Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography,Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    table: {
        overflowX: 'auto',
    },
    cell: {
        padding: theme.spacing(0.5, 1) + '!important'
    },
    action: {
        padding: theme.spacing(0.5, 1) + '!important',
        flex: 1,
        display: 'flex',
        justifyContent: 'flex-end'
    },
    checkbox:{
        padding:0
    }
}));

export default function CustomTable(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const { columns, rows, showHeader, columnAction, textMedium, hiddenFields,customColumns } = props;

    return (
        <>
            <Grid item className={classes.table}>
                <Table>
                    {showHeader && <TableHead>
                        <TableRow>
                            {columns && columns.length > 0 && columns.map((item, index) => (
                                <TableCell classes={{ root: classes.cell }} key={index}>
                                    <Typography variant={textMedium ? null : 'headBold'}>{item.name}</Typography>
                                </TableCell>
                            ))}
                            {columnAction && <TableCell classes={{ root: classes.action }}>
                                <Typography variant={textMedium ? null : 'headBold'}>{columnAction.title}</Typography>
                            </TableCell>}
                        </TableRow>
                    </TableHead>}
                    <TableBody>
                        {rows && rows.length > 0 && rows.map((row, rowIdx) => {
                            let fields = Object.getOwnPropertyNames(row);
                            return (
                                <TableRow key={rowIdx}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    {fields.map((column, cellIdx) => {
                                        let isHidden = hiddenFields && hiddenFields.filter(f => {
                                            return f == column;
                                        })
                                        if (!isHidden || isHidden.length == 0) {
                                            if(customColumns&&customColumns.length > 0){
                                                let customColumn = customColumns.filter(c => {
                                                    return c.column == column;
                                                })
                                                if(customColumn && customColumn.length > 0){
                                                    return (<TableCell classes={{ root: classes.cell }} key={cellIdx}>
                                                        {customColumn[0].type=='checkbox' && <Checkbox onClick={() => customColumn[0].onClick(row)} classes={{root:classes.checkbox}} checked={row[column] == 'true' ? true : false}/>}
                                                    </TableCell>)
                                                }else{
                                                    return (<TableCell classes={{ root: classes.cell }} key={cellIdx}>
                                                        <Typography variant={textMedium ? 'body1' : "normal"} className={classes.namecss}>
                                                            {row[column]}
                                                        </Typography>
                                                    </TableCell>)
                                                }
                                            }else{ 
                                                return (
                                                    <TableCell classes={{ root: classes.cell }} key={cellIdx}>
                                                        <Typography variant={textMedium ? 'body1' : "normal"} className={classes.namecss}>
                                                            {row[column]}
                                                        </Typography>
                                                    </TableCell>
                                                );
                                            }
                                        }
                                    })}
                                    {columnAction &&
                                        <TableCell classes={{ root: classes.action }}>
                                            <Button size='small' onClick={() => columnAction.onClick(row)}>
                                                {columnAction.icon ? columnAction.icon : null}
                                                {columnAction.label ? columnAction.label : null}
                                            </Button>
                                        </TableCell>
                                    }
                                </TableRow>
                            );
                        })}
                        {rows && rows.length <= 0 && <Grid item xs={12}>
                            <Typography>{t('no_data_found')}</Typography>
                        </Grid>}
                    </TableBody>
                </Table>
            </Grid>
        </>
    );
}